import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import mycolor from '@/mycolor.js';

Vue.use(Vuex);



const state = {
	user: null,
	notices: [],
};


// gettersはcomputedのreturn で呼び出す.
// return this.$store.getters.user

const store = new Vuex.Store({
	state,
	plugins: [createPersistedState()],
	getters: {
		user: (state) => {
			return state.user;
		},
		user_name: (state) => {
			return state.user.sei + ' ' + state.user.mei;
		},
		is_admin: (state) => {
			if( state.user.auth=='管理者' || state.user.auth=='チーフ' ){
				return true;
			}else{
				return false;
			}
		},

        // 通知
		notices: (state) => {
			return state.notices;
		},

	},
	actions: {
		user(context, user){
			console.log('%c 1. actions user', mycolor.pink);
			context.commit('user', user);
		},
		notices(context, notices){
			console.log('%c 1. actions notices', mycolor.pink);
			context.commit('notices', notices);
		}
	},
	mutations: {
		user(state, user){
			console.log('%c 2. mutations user', mycolor.pink);
			state.user = user;
		},
		notices(state, notices){
			console.log('%c 2. mutations notices', mycolor.pink);
			state.notices = notices;
		}
	},
});


export default store;
